export default "__VITE_ASSET__wCsIdo0g__"